import { SVGProps } from "react";

export default function PresentationChartIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 16, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.93414 13.3333H12.0608C13.3275 13.3333 13.9941 12.6667 13.9941 11.4V3.33334H1.99414V11.4C2.00081 12.6667 2.66748 13.3333 3.93414 13.3333Z"
        stroke="#545454"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33398 3.33334H14.6673"
        stroke="#545454"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M5.33398 16.6667L8.00065 15.3333M8.00065 15.3333V13.3333M8.00065 15.3333L10.6673 16.6667"
          stroke="#545454"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.4"
        d="M5 9.33334L7.1 7.58001C7.26666 7.44001 7.48666 7.48001 7.6 7.66668L8.4 9.00001C8.51334 9.18668 8.73334 9.22001 8.9 9.08668L11 7.33334"
        stroke="#444D5A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}